/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'; // eslint-disable-line
import { Button, Grid, InputAdornment, Typography, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import styles, { StyledComponent } from '../../../../../styles/styles';
import {
    FullWidthSearchSelectField,
    FullWidthTextField,
    GenericForm,
    WhenFieldChanges,
} from '../../../../../forms';
import { State } from '../../../../../redux/root-reducer';
import {
    ClaimantRequirements,
    getDeathRequirementsFromClaim,
} from '../../../common/requirements-management/reducer';
import { Add, Delete } from '@material-ui/icons';
import { RequiredDocumentsView } from '../../../common/requirements-management/views';
import {
    isEmpty,
    conditionalRequired,
    requiredValidator,
    rsaIdNumberValidator,
    composeValidators,
} from '../../../../../forms/validations';
import { Claim, getClaim } from '../../../../../claim';
import { BeneficiaryOption } from '../../../../../payment/reducer';
import { EmailMask } from '../../../../../forms/input-masks/email-mask';
import { DeathRequirements } from '../reducer';
import { closeModalAction } from '../../../../../form-modal/actions';
import { DocumentOwnerType } from '../../../../../shared-types';
import { ClaimType } from '../../../../../claim/claim-types';
import {
    parseStringToDate,
    getDisplayNameFromAdName,
    getFullName,
} from '../../../../../shared-functions';
import { Titles } from '../../../../../codes/titles';
import {
    LifeAssuredDetails,
    getLifeAssuredDetails,
} from '../../../../../life-assured-details/reducer';
import { FormSpy } from 'react-final-form';
import { FormApi } from 'final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import { ClassNameMap } from '@material-ui/styles';
import { viewModalAction } from '../../../../../confirmation-dialog';
import { communicationAction } from '../actions/communication-action';
import { AuthState } from '../../../../../auth/auth-reducer';
import { NumberMask } from '../../../../../forms/input-masks';
import { DeathClaim } from '../../../../../claim/reducers/claim-reducers/death-claim-reducer';

type InnerProps = {
    form: FormApi<any>;
};

type Props = StyledComponent &
    InnerProps & {
        claimantRequirements: ClaimantRequirements[];
        claim: Claim;
        isShowDocumentRequirements?: boolean;
        lifeAssuredDetails: LifeAssuredDetails;
        isUnderInvestigation?: boolean;
        policyNumber?: string;
        isDocumentRequested?: boolean;
    };

type InnerFormProps = {
    claimants: any;
    documents: any;
    updateRequirements: any;
    updateModalData: any;
    currentUser: AuthState;
};

let currentTitle = '';
let currentClaimant = '';
let currentClaimantId = '';
let currentSurname = '';
let currentPolicyNumber: Array<any> = [];
let currentEmail = '';
let currentEmails: Array<any> = [null];
let currentIdNumber = '';
export interface Communications {
    communicationsClaimant?: string;
    communicationsEmailAddress?: string;
    communicationsAdditionalEmails?: Array<any>;
    requiredDocumentsBody?: string;
    communicationsPolicy: string;
    idNumber?: string;
    communicationsTitle?: string;
}

const CommunicationsForm = GenericForm<Communications>();

const CommunicationEdit: React.FunctionComponent<any> = ({
    classes,
    claimantRequirements,
    claim,
    currentUser,
    communicationAction,
    lifeAssuredDetails,
    closeModal,
    updateModalData,
    isShowDocumentRequirements,
    isUnderInvestigation,
    policyNumber,
    isDocumentRequested,
    ...rest
}: any) => {
    const deseasedDocs = claim.requirements?.lifeAssured?.documents.filter(
        (document: any) => document.status === 'Requested'
    );
    const [counter, setCounter] = useState<number>(0);
    const [initialPolicyNumber, setInitialPolicyNumber] = useState<string>('');

    useEffect(() => {
        setCounter(prev => prev + 1);
        const storedPolicy = currentPolicyNumber?.[0];
        if (storedPolicy && typeof storedPolicy === 'string') {
            setInitialPolicyNumber(storedPolicy);
        }
        currentTitle = '';
        currentClaimant = '';
        currentClaimantId = '';
        currentSurname = '';
        currentPolicyNumber = [null];
        currentEmail = '';
        currentEmails = [null];
        currentIdNumber = '';
    }, []);

    isDocumentRequested = false;
    let isLifeAssuredDocRequested = false;
    if (deseasedDocs?.length > 0) {
        isLifeAssuredDocRequested = true;
    }

    const docs = claim.requirements?.policyOwner?.documents;

    const isPolicyOwnerDocumentRequested =
        docs?.some((document: { status: string }) => document.status === 'Requested') ?? false;

    const claimants = getClaimantOptions(
        claim,
        isPolicyOwnerDocumentRequested,
        isLifeAssuredDocRequested,
        claimantRequirements,
        !isShowDocumentRequirements
    );

    let requirements: any = [];
    let documents: any = [];
    const updateRequirements = (id: string) => {
        requirements = claimantRequirements.find((item: any) => item.claimantId === id);

        documents =
            requirements && requirements.documents
                ? requirements.documents.filter((document: any) => document.status === 'Requested')
                : [];

        const lifeAssuredDocs = claim.documentsStatus.deceased.filter(
            (document: any) => document.status === 'Requested'
        );

        lifeAssuredDocs.forEach(
            (document: { id: any; status: any; reason: any; dateRequested: any; name: any }) => {
                documents.push({
                    id: document.id,
                    status: document.status || '',
                    reason: document.reason,
                    dateRequested: document.dateRequested,
                    name: document.name,
                });
            }
        );
        return documents;
    };

    const onSubmit = async (values: Communications) => {
        const getDocuments = () => {
            const docs: Array<string | undefined> = [];
            documents.map((a: any) => {
                docs.push(a.name);
                return docs;
            });
            return docs.toString();
        };

        const policyOwnerIndex = claimantRequirements.findIndex(
            (item: any) => item.id === DocumentOwnerType.PolicyOwner
        );

        if (policyOwnerIndex > -1) claimantRequirements.splice(policyOwnerIndex, 1);

        const creationDate = sessionStorage.getItem('creationDate');

        const deathClaim = claim as DeathRequirements;
        const policyOwner = deathClaim?.policyOwner;
        const isPolicyOwner = policyOwner && !isEmpty(policyOwner);

        communicationAction({
            to: values.communicationsEmailAddress,
            ccs: values.communicationsAdditionalEmails
                ? values.communicationsAdditionalEmails.filter(x => x !== null && x !== undefined)
                : [],
            requiredDocuments: getDocuments(),
            claimantId: isPolicyOwner
                ? values.communicationsClaimant
                : getClaimantId(values.communicationsClaimant),
            claimantName:
                claimants.length === 0 || !Array.isArray(claimants)
                    ? getManualEnteredName(
                          values.communicationsClaimant,
                          values.communicationsTitle
                      )
                    : getName(
                          values.communicationsClaimant,
                          values.communicationsTitle,
                          values.communicationsClaimant
                      ),
            idNumber: values?.idNumber,
            claimDate: parseStringToDate(creationDate !== null ? creationDate : ''),
            claimantPolicy: values.communicationsPolicy,
            assessor: getDisplayNameFromAdName(currentUser.name),
            communicationType: isShowDocumentRequirements
                ? 'Missing Information'
                : 'Assessor Allocation',
        }).then(() => {
            currentTitle = '';
            currentClaimant = '';
            currentClaimantId = '';
            currentEmail = '';
            currentEmails = [null];
            currentPolicyNumber = [];
            currentIdNumber = '';
            closeModal();
        });
    };

    const getName = (val: any, title: any, name: any) => {
        const claimant = claimants.find(item => item.value === val);
        if (!claimant || !claimant.value) {
            return getManualEnteredName(name, title);
        }

        const titleRegex = new RegExp(`^(${Titles.map(t => t.label).join('|')})\\s+`, 'i');

        const match =
            claimant.value === 'Policy Owner'
                ? claimant.label.match(titleRegex)
                : claimant.value.match(titleRegex);
        const extractedTitle = match ? match[1] : '';

        const newName = claimant.label.replace(titleRegex, '').trim();

        claimant.label = `${
            currentTitle !== undefined && currentTitle !== '' ? currentTitle : extractedTitle
        } ${newName}`;

        return claimant.label;
    };

    const getManualEnteredName = (name?: string, title?: string) => {
        const fullName = `${title} ${name}`;
        return fullName;
    };

    const getClaimantId = (val: any) => {
        const claimant: any = claimants.find((item: any) => item.claimantId === currentClaimantId);
        return claimant?.claimantId;
    };

    currentClaimant = counter > 0 ? currentClaimant : '';
    currentTitle = counter > 0 ? currentTitle : '';

    useEffect(() => {
        if (counter === 0) {
            setInitialPolicyNumber('');
        }
    }, [counter]);

    const hasContracts = lifeAssuredDetails?.contracts?.length > 0;

    const initialValues = {
        communicationsClaimant: currentClaimant || '',
        communicationsEmailAddress: currentEmail || '',
        requiredDocumentsBody: '',
        communicationsTitle: currentTitle || '',
        communicationsPolicyNumber: initialPolicyNumber || '',
        communicationsPolicy: hasContracts
            ? initialPolicyNumber || currentPolicyNumber || ''
            : initialPolicyNumber || '',
        claimantName: '',
        communicationsAdditionalEmails: currentEmails || [null],
        idNumber: currentIdNumber || '',
    };

    return (
        <CommunicationsForm
            onSubmit={onSubmit}
            initialValues={initialValues}
            {...rest}
            mutators={{
                // potentially other mutators could be merged here
                ...arrayMutators,
            }}
        >
            {() =>
                FormSpy<any>({
                    render: ({ form }) =>
                        InnerForm({
                            claimantRequirements,
                            claim,
                            currentUser,
                            lifeAssuredDetails,
                            classes,
                            updateRequirements,
                            isShowDocumentRequirements,
                            isUnderInvestigation,
                            policyNumber,
                            claimants,
                            documents,
                            form,
                            updateModalData,
                        }),
                })
            }
        </CommunicationsForm>
    );
};

export function getClaimantOptions(
    claim: Claim,
    isDocumentRequested?: boolean,
    isLifeAssuredDocRequested?: boolean,
    claimantDocs?: any,
    isAllocationComms?: boolean
) {
    const commsClaimants: BeneficiaryOption[] = [];

    if (claim.claimType === ClaimType.Death) {
        const deathClaim = claim as DeathClaim;
        if (deathClaim.contactDetails) {
            const claimants = deathClaim.contactDetails?.claimants;

            if (claimants) {
                claimants.forEach(claimant => {
                    const requirements =
                        claimantDocs.find((item: any) => item.claimantId === claimant.id) ??
                        claimantDocs;
                    const source = requirements?.documents ?? requirements ?? [];
                    const missingDocuments = requirements
                        ? source.filter((document: any) => document.status === 'Requested')
                        : [];

                    if (claimant.id) {
                        if (
                            !commsClaimants.includes({
                                value: claimant?.id || '',
                                label: getFullName(claimant?.claimantDetails?.personalDetails),
                                claimantId: claimant?.id,
                            })
                        )
                            if (
                                missingDocuments.length > 0 ||
                                isLifeAssuredDocRequested ||
                                isAllocationComms
                            ) {
                                commsClaimants.push({
                                    value: getFullName(claimant?.claimantDetails?.personalDetails),
                                    label: getFullName(claimant?.claimantDetails?.personalDetails),
                                    title: getByTitle(claimant?.claimantDetails?.personalDetails),
                                    email: getEmailAddress(claimant?.claimantDetails),
                                    surname: getSurname(claimant?.claimantDetails?.personalDetails),
                                    claimantId: claimant?.id,
                                    communicationsPolicy: deathClaim.contracts
                                        ?.map(contract => contract.contractNumber)
                                        ?.join(', '),
                                });
                            }
                    }
                });

                if (claimants.length === 0 && (currentClaimant !== '' || currentTitle !== '')) {
                    let claimantName = currentClaimant?.trim() || '';
                    let claimantTitle = currentTitle?.trim() || '';

                    if (!claimantTitle && claimantName) {
                        const parts = claimantName.split(/\s+/);
                        const firstWord = parts[0].replace('.', '').toLowerCase();

                        const matchedTitle = Titles.find(t => t.label.toLowerCase() === firstWord);

                        if (parts.length > 1 && matchedTitle) {
                            claimantTitle = matchedTitle.label;
                            claimantName = parts.slice(1).join(' ');
                        }
                    }

                    commsClaimants.push({
                        value: claimantName,
                        label: `${claimantTitle} ${claimantName}`.trim(),
                        title: claimantTitle,
                        surname: currentSurname,
                    });
                }
            }
        }
    }

    return commsClaimants;
}

const getByTitle = (personalDetails: any) => {
    if (personalDetails && currentTitle !== '') {
        personalDetails.title = currentTitle;
    }
    return personalDetails?.title;
};

const getSurname = (personalDetails: any) => {
    return personalDetails?.lastName;
};

const getEmailAddress = (contactDetails: any) => {
    return contactDetails?.communicationDetails?.emailAddress;
};

const InnerForm = ({
    claimantRequirements,
    claim,
    currentUser,
    lifeAssuredDetails,
    classes,
    updateRequirements,
    claimants,
    documents,
    form,
    isShowDocumentRequirements,
    isUnderInvestigation,
    policyNumber,
    updateModalData,
}: Props & InnerFormProps) => {
    const deathRequirements = getDeathRequirementsFromClaim(claim) as DeathRequirements;
    const policyOwnerRequirements = deathRequirements.policyOwner;
    const validClaimantExists = claimants.some(
        (c: any) =>
            !!c.claimantId &&
            !!c.surname &&
            !!c.title &&
            c.surname.trim() !== '' &&
            c.title.trim() !== ''
    );

    if (
        policyOwnerRequirements &&
        policyOwnerRequirements.documents &&
        policyOwnerRequirements.documents.length > 0
    ) {
        if (!claimantRequirements?.some(item => item.id === DocumentOwnerType.PolicyOwner))
            claimantRequirements.push({
                ...policyOwnerRequirements,
                id: DocumentOwnerType.PolicyOwner,
            });
    }

    const policies: any = [];

    if (
        lifeAssuredDetails &&
        lifeAssuredDetails.contracts &&
        lifeAssuredDetails.contracts.length > 0
    ) {
        lifeAssuredDetails.contracts.map((x: any) => {
            policies.push({ label: x.contractNumber, value: x.contractNumber });
            return policies;
        });
    }

    const updateTitle = (val: string) => {
        const claimant: any = claimants.find((item: any) => item.claimantId === currentClaimantId);
        if (val !== '') {
            if (claimant && currentTitle !== '') {
                if (claimant?.title !== currentTitle) {
                    claimant.title = val;
                    return currentTitle;
                }
            }

            return claimant?.title;
        }
        updateModalData({
            form: form.getState()?.values,
        });
    };

    const emailAddress = (val: string) => {
        const claimant: any = claimants.find((item: any) => item.value === val);
        if (val !== '') {
            return claimant?.email;
        }
    };

    const claimantSurname = (val: string) => {
        const claimant: any = claimants.find((item: any) => item.value === val);
        if (val !== '') {
            return claimant?.surname;
        }
    };

    function getSurname(fullName: string): string {
        if (!fullName) return '';

        const parts = fullName.trim().split(/\s+/);
        return parts.length > 1 ? parts[parts.length - 1] : '';
    }

    const uodatePolicy = (e: string) => {
        const formDetails = form.getState()?.values;
        currentEmail = formDetails?.communicationsEmailAddress;
        currentEmails = formDetails?.communicationsAdditionalEmails;
        if (!currentPolicyNumber.includes(e)) {
            currentPolicyNumber.push(e);
        }

        formDetails.communicationsPolicy = currentPolicyNumber;
        formDetails.idNumber = currentIdNumber;
        updateModalData({
            form: formDetails,
        });
    };

    const { push } = form.mutators;

    return (
        <Grid container item xs={12}>
            <Grid>
                <Grid container style={{ marginBottom: '-40px' }}>
                    {isShowDocumentRequirements && (
                        <Grid item xs={6} lg={6} style={{ marginTop: '20px' }}>
                            <Typography className={classes.heading} variant="body2">
                                Requested Documentation
                            </Typography>
                            <RequiredDocumentsView documents={documents} isElevated={true} />
                        </Grid>
                    )}
                    <Grid item xs={6} lg={6}>
                        <Grid container spacing={5} style={{ marginBottom: '120px' }}>
                            <Grid item xs={12} lg={12}>
                                {(claimants.length > 0 && validClaimantExists) ||
                                (claim.claimType === ClaimType.Death &&
                                    isShowDocumentRequirements &&
                                    claimants.length > 0) ? (
                                    <FullWidthSearchSelectField
                                        name="communicationsClaimant"
                                        label="Claimant"
                                        validate={requiredValidator}
                                        helperText="Name of claimant"
                                        options={claimants}
                                        onChange={(val: string) => {
                                            const selectedClaimant = claimants.find(
                                                (x: any) => x.value === val
                                            );
                                            currentClaimant = val;
                                            currentClaimantId = selectedClaimant?.claimantId;
                                            return currentClaimantId;
                                        }}
                                    />
                                ) : (
                                    <FullWidthTextField
                                        name="communicationsClaimant"
                                        label="Claimant"
                                        validate={requiredValidator}
                                        helperText="Name of claimant"
                                        onChange={e => {
                                            currentClaimant = e.target.value;
                                        }}
                                    />
                                )}
                            </Grid>
                            {claimants.length !== 0 && (
                                <WhenFieldChanges
                                    field={'communicationsClaimant'}
                                    set={'communications'}
                                    to={(val: any) => {
                                        if (val !== '') {
                                            const selectedClaimant = claimants.find(
                                                (x: any) => x.value === val
                                            );

                                            const id = selectedClaimant?.claimantId;

                                            updateModalData({
                                                form: form.getState()?.values,
                                            });

                                            updateRequirements(id);

                                            return id;
                                        }
                                    }}
                                />
                            )}
                            <WhenFieldChanges
                                field={'communicationsClaimant'}
                                set={'test'}
                                to={(val: any) => {
                                    const formValues = form.getState()?.values;
                                    currentClaimant = formValues?.communicationsClaimant;
                                    currentSurname = getSurname(currentClaimant);
                                }}
                            />

                            {isUnderInvestigation !== undefined && isUnderInvestigation && (
                                <>
                                    <Grid item xs={12} lg={12}>
                                        <FullWidthTextField
                                            name="communicationsSurname"
                                            label="Claimant surname"
                                            validate={requiredValidator}
                                            helperText="Surname of claimant"
                                        />
                                    </Grid>
                                    <WhenFieldChanges
                                        field={'communicationsClaimant'}
                                        set={'communicationsSurname'}
                                        to={(val: string) => claimantSurname(val)}
                                    />
                                </>
                            )}
                            <Grid item xs={12} lg={12}>
                                <FullWidthSearchSelectField
                                    name="communicationsTitle"
                                    label="Title"
                                    validate={requiredValidator}
                                    helperText="Title of claimant"
                                    options={Titles}
                                    onChange={(val: string) => {
                                        currentTitle = val;
                                    }}
                                />
                                {claimants.length !== 0 && (
                                    <>
                                        <WhenFieldChanges
                                            field={'communicationsClaimant'}
                                            set={'communicationsTitle'}
                                            to={(val: string) => {
                                                if (val !== '') {
                                                    const selectedClaimant = claimants.find(
                                                        (x: any) => x.value === val
                                                    );

                                                    const id = selectedClaimant?.claimantId;

                                                    updateTitle(id);
                                                }
                                            }}
                                        />
                                        <WhenFieldChanges
                                            field={'communicationsTitle'}
                                            set={'tester'}
                                            to={(val: string) => {
                                                if (val !== '') {
                                                    const selectedClaimant = claimants.find(
                                                        (x: any) => x.value === val
                                                    );

                                                    const id = selectedClaimant?.claimantId;

                                                    updateTitle(id);
                                                }
                                            }}
                                        />
                                    </>
                                )}
                            </Grid>
                            {(claimants.length === 0 || !validClaimantExists) &&
                                !(
                                    claim.claimType === ClaimType.Death &&
                                    isShowDocumentRequirements &&
                                    claimants.length > 0
                                ) && (
                                    <Grid item xs={12} lg={12}>
                                        <FullWidthTextField
                                            name="idNumber"
                                            label="ID Number"
                                            helperText="Id number of claimant"
                                            validate={composeValidators(
                                                requiredValidator,
                                                rsaIdNumberValidator
                                            )}
                                            mask={NumberMask}
                                        />
                                        <WhenFieldChanges
                                            field={'idNumber'}
                                            set={'communicationIdNumber'}
                                            to={(_val: string) => {
                                                currentIdNumber = _val;
                                                return _val;
                                            }}
                                        />
                                    </Grid>
                                )}
                            <Grid item xs={12} lg={12}>
                                <FullWidthTextField
                                    name="communicationsEmailAddress"
                                    label="E-mail Address"
                                    validate={requiredValidator}
                                    mask={EmailMask}
                                    onChange={(
                                        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                                    ) => {
                                        const value = e.target.value;
                                        currentEmail = value;
                                    }}
                                    helperText="Recipient of Assessor Allocation E-mail Communication"
                                />
                                {claimants.length !== 0 &&
                                    claimants.some((c: { claimantId: any }) => c.claimantId) && (
                                        <WhenFieldChanges
                                            field={'communicationsClaimant'}
                                            set={'communicationsEmailAddress'}
                                            to={(val: string) => emailAddress(val)}
                                        />
                                    )}
                            </Grid>
                            {(isUnderInvestigation === undefined || !isUnderInvestigation) && (
                                <>
                                    <Grid item xs={12} lg={12}>
                                        <FieldArray
                                            name="communicationsAdditionalEmails"
                                            key={`communicationsAdditionalEmails`}
                                        >
                                            {({ fields }) =>
                                                fields.map(addtionalEmailRow(form, fields, classes))
                                            }
                                        </FieldArray>
                                    </Grid>
                                    <Grid item xs={12} lg={12}>
                                        <Button
                                            startIcon={<Add />}
                                            variant="contained"
                                            color="secondary"
                                            name="addAdditionalEmail"
                                            fullWidth
                                            disableElevation
                                            style={{ transform: 'none' }}
                                            onClick={() =>
                                                push('communicationsAdditionalEmails', undefined)
                                            }
                                            disabled={form
                                                .getState()
                                                ?.values?.communicationsAdditionalEmails?.some(
                                                    (email: string) =>
                                                        !email?.trim() ||
                                                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                                                )}
                                        >
                                            Add Email Address
                                        </Button>
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12} lg={12}>
                                {lifeAssuredDetails?.contracts?.length > 0 &&
                                policies.length > 0 ? (
                                    <FullWidthSearchSelectField
                                        name="communicationsPolicy"
                                        label="Policy"
                                        validate={requiredValidator}
                                        helperText="Policy for which the claim is being made"
                                        onChange={(e: string | '') => {
                                            currentPolicyNumber = [];
                                            currentPolicyNumber.push(e);
                                            uodatePolicy(e);
                                        }}
                                        options={policies}
                                    />
                                ) : (
                                    <>
                                        <FullWidthTextField
                                            name="communicationsPolicyNumber"
                                            label="Policy"
                                            helperText="Policy for which the claim is being made"
                                            validate={requiredValidator}
                                            mask={NumberMask}
                                        />
                                        <WhenFieldChanges
                                            field="communicationsPolicyNumber"
                                            set="communicationsPolicy"
                                            to={(e: string) => {
                                                currentPolicyNumber = [e];
                                                uodatePolicy(e);
                                                return e;
                                            }}
                                        />
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

function addtionalEmailRow(form: any, fields: any, classes: ClassNameMap<string>) {
    const remove = (fields: any, index: number) => {
        if (fields.length > 1) {
            fields.remove(index);
        } else {
        }
    };

    return function _addtionalEmailRow(_policyNumber: any, index: number) {
        return (
            <React.Fragment key={`communicationsAdditionalEmails[${index}]`}>
                <FullWidthTextField
                    name={`communicationsAdditionalEmails[${index}]`}
                    label="Additional email address"
                    helperText="Additional recipient to receive E-mail communication"
                    mask={EmailMask}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                        const value = e.target.value;
                        currentEmails.push(value);
                    }}
                    validate={conditionalRequired(
                        values =>
                            (values &&
                                values.communicationsAdditionalEmails &&
                                values.communicationsAdditionalEmails[index + 1] &&
                                values.communicationsAdditionalEmails[index + 1] !== undefined &&
                                values.communicationsAdditionalEmails[index + 1] !== null) ||
                            index > 0
                    )}
                    endadornment={
                        fields.length > 1 ? (
                            <InputAdornment position="end">
                                <Delete
                                    style={{ cursor: 'default' }}
                                    color="error"
                                    onClick={() => remove(fields, index)}
                                />
                            </InputAdornment>
                        ) : undefined
                    }
                />
            </React.Fragment>
        );
    };
}

const mapStateToProps = (state: State) => {
    const claim = getClaim(state);
    const requirements = getDeathRequirementsFromClaim(claim) as DeathRequirements;

    const props = {
        claim,
        currentUser: state.auth as AuthState,
        lifeAssuredDetails: getLifeAssuredDetails(state),
        claimantRequirements: requirements?.claimants || [],
    };

    return props;
};

const mapDispatchToProps = {
    communicationAction: communicationAction,
    closeModal: closeModalAction,
    updateModalData: viewModalAction,
};

export const CommunicationEditView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CommunicationEdit));
